import axios from 'axios';
import store from '@/store/Store';

const API_URL = import.meta.env.VITE_API_URL;

export const fetchUserData = async () => {
  const token = store.getState().auth.token;
  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(API_URL + '/user', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};
